
import { Vue, Component } from 'vue-property-decorator'
import User from '@/types/user'

@Component({
  components: {}
})

export default class CustomerUserShowDetailsTab extends Vue {
  settings = {
    routeNames: { show: 'customerUserShow', edit: 'customerUserEdit' },
    routeParamKey: 'customerUserId',
    functionNames: { setCurrent: 'setCurrentCustomerUser', clearCurrent: 'clearCurrentCustomerUser', save: 'saveCustomerUser' },
    getterNames: { current: 'currentCustomerUser', loading: 'loadingCustomerUser', errors: 'customerUserErrors' }
  }

  get currentItem () : User {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get errors () : { [key:string]: string[] } {
    return this.$store.getters[this.settings.getterNames.errors]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }

  get saving () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].save
  }
}
